import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

const {
  string,
  bool,
  oneOf
} = PropTypes;
const ButtonLink = ({
  className,
  full,
  inverse,
  size,
  variant,
  spinner,
  disabled,
  label,
  ...props
}) => {
  const classNames = cx(full && `tds-button_full`, size && `tds-button_${size}`, variant && !inverse && `tds-button_${variant} slds-button_${variant}`, variant && inverse && `tds-button_${variant}-inverse`, className, "slds-button slds-show_inline-block");
  return /*#__PURE__*/React.createElement("a", Object.assign({}, props, {
    className: classNames,
    disabled: disabled || spinner
  }), label);
};
ButtonLink.displayName = "ButtonLink";
ButtonLink.defaultProps = {
  className: null,
  label: null,
  disabled: false,
  full: false,
  inverse: false,
  spinner: false,
  size: null,
  variant: null
};
ButtonLink.propTypes = {
  /**
   * CSS class name to be applied to `<a />` tag.
   */
  className: string,
  /**
   * The text contents of the `<a />` tag.
   */
  label: string,
  /**
   * Disables button, prevents clicks.
   */
  disabled: bool,
  /**
   * Makes button take the full width of its container.
   */
  full: bool,
  /**
   * Inverts colors, use a container with a dark background.
   */
  inverse: bool,
  /**
   * Same as `disabled` prop, for some reason. Does not actually display a spinning icon.
   */
  spinner: bool,
  /**
   * Size variants.
   */
  size: oneOf(["small", "medium", "large", "xlarge", "x-large"]),
  /**
   * Button variants.
   */
  variant: oneOf(["base", "neutral", "brand", "destructive", "success", "danger", "tertiary", "important"])
};
var ButtonLink$1 = ButtonLink;

export { ButtonLink$1 as default };
